<div class="mt-3">
	<button class="btn btn-primary btn-sm" (click)="onAddDocument()" *ngIf="!viewMode">
		<i class="fa fa-plus"></i> Add Document
	</button>
	<table class="table">
		<thead>
			<tr>
				<th>Source</th>
				<th>Doc Type</th>
				<th>Is Final Document?</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let document of documents; let documentIndex = index">
				<td>
					<cv-dropdown
						[required]="true"
						[label]="''"
						[placeholder]="'Select a Source'"
						[selectedValue]="document.documentSource"
						[options]="sourceList"
						(valuesChange)="onDocumentSourceSelected($event, documentIndex)"
						[disabled]="viewMode"
					>
					</cv-dropdown>
				</td>
				<td class="document-type">
					<cv-multiselect-search
						[required]="true"
						[label]="''"
						[placeholder]="'Select a Document Type'"
						[values]="getDocumentTypeValue('Appscope', document.documentType)"
						[options]="appAscopeList"
						[optionText]="'name'"
						*ngIf="document.documentSource === 'Appscope'"
						(valuesChange)="onDocumentTypeSelected('appscope', $event, documentIndex)"
						[disabled]="viewMode"
					>
					</cv-multiselect-search>

					<cv-multiselect-search
						[required]="true"
						[label]="''"
						[placeholder]="'Select a Document Type'"
						[values]="getDocumentTypeValue('Acuity', document.documentType)"
						[options]="acuityList"
						[optionText]="'name'"
						*ngIf="document.documentSource === 'Acuity'"
						(valuesChange)="onDocumentTypeSelected('acuity', $event, documentIndex)"
						[disabled]="viewMode"
					>
					</cv-multiselect-search>

					<cv-multiselect-search
						[required]="true"
						[label]="''"
						[placeholder]="'Select a Document Type'"
						[values]="getDocumentTypeValue('class', document.documentType)"
						[options]="classList"
						[optionText]="'name'"
						*ngIf="document.documentSource === 'Class'"
						(valuesChange)="onDocumentTypeSelected('class', $event, documentIndex)"
						[disabled]="viewMode"
					>
					</cv-multiselect-search>

					<cv-multiselect-search
						[required]="true"
						[label]="''"
						[placeholder]="'Select a Document Type'"
						[values]="getDocumentTypeValue('cmpacuity', document.documentType)"
						[options]="cmpAcuityList"
						[optionText]="'name'"
						*ngIf="document.documentSource === 'cmpacuity'"
						(valuesChange)="onDocumentTypeSelected('cmpacuity', $event, documentIndex)"
						[disabled]="viewMode"
					>
					</cv-multiselect-search>

				</td>
				<td class="switch">
					<cv-switch
						[class]="'cv-switch-blue'"
						[checked]="document.isFinalDocument"
						[size]="'sm'"
						(valueChange)="onFinalDocument($event, documentIndex)"
						[disabled]="viewMode"
					></cv-switch>
				</td>
				<td>
					<button class="btn btn-primary btn-sm" (click)="onDeleteDocument(documentIndex)" *ngIf="!viewMode">
						<i class="fa fa-trash"></i>
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</div>
